import { httpCreate } from './http';

const http = httpCreate('/srv/coupon-detail');

export const couponDetail = {
	priceList() {
		return http.get('/getPriceList');
	},
	myList(params) {
		return http.get('/myList', { params: params });
	},
	exchangeCode(code) {
		return http.post(`/${code}/exchange`);
	},
	num() {
		return http.get('/number');
	},
};
